export default "__VITE_ASSET__9322047e__"